import { WithAdSetSyncState } from "./adSetsReducer";

export const adSets = ({ adSets: sets }: WithAdSetSyncState) => (sets && typeof sets !== "string" ? sets : []);
